<template>
  <section class="section-careers">
    <div class="container">
      <div class="section-space-50"></div>
      <div class="section-header-title">Careers</div>
      <template v-if="customer_care_email">
        <div v-html="updatedParagraph"></div>
      </template>
      <template v-else>
        <p>
          We strongly believe that the quality of our customer service directly reflects to how satisfied and united our employees are.<br/>
          A fun loving workplace & regarded as one of the best employers, our continual commitment towards employee 
          development has become one of its success story. At Miraj, we recognize that the real strength and 
          the foundation of our business are Our People. We firmly believe in growing our people holistically & build careers.<br/>
          To be part of this vibrant team, send in your resume at <a class="text-rose-gold" href="mailto:contactus@mirajcinemas.com">contactus@mirajcinemas.com</a>
        </p>
      </template>

      <div class="row">
        <div class="col-12">
          <div class="search-careers-container career-dropdown">
            <div class="title">Search for jobs</div>
            <div class="row">
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4 mb-3 mb-md-0 career-dropdown">
                    <div class="has-chevron">
                      <b-dropdown
                        no-caret
                        variant="transparent"
                        class="w-100 border rounded text-left dd-menu-100"
                      >
                        <template v-slot:button-content>
                          <div class="text-left">
                            {{ selectedCity ? selectedCity : "Select City" }}
                          </div>
                        </template>
                        <b-dropdown-item
                          v-for="(fndItems, fndItemsKey) in cities"
                          :key="fndItemsKey"
                          @click="
                            onHandleCitySelect(
                              fndItems.city_id,
                              fndItems.city_name
                            )
                          "
                          >{{ fndItems.city_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <div class="col-md-4 px-md-0 mb-3 mb-md-0">
                    <div class="has-chevron">
                      <b-dropdown
                        no-caret
                        variant="transparent"
                        class="w-100 border rounded text-left dd-menu-100"
                      >
                        <template v-slot:button-content>
                          <div class="text-left">
                            {{
                              selectedDepartment
                                ? selectedDepartment
                                : "Select Department"
                            }}
                          </div>
                        </template>
                        <b-dropdown-item
                          v-for="(fndItems, fndItemsKey) in jobDepartments"
                          :key="fndItemsKey"
                          @click="
                            onHandleDepartmentSelect(
                              fndItems.job_department_id,
                              fndItems.job_department
                            )
                          "
                          >{{ fndItems.job_department }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3 mb-md-0">
                    <div class="has-chevron">
                      <b-dropdown
                        no-caret
                        variant="transparent"
                        class="w-100 border rounded text-left dd-menu-100"
                      >
                        <template v-slot:button-content>
                          <div class="text-left">
                            {{
                              selectedRole ? selectedRole : "Select Job role"
                            }}
                          </div>
                        </template>
                        <b-dropdown-item
                          v-for="(fndItems, fndItemsKey) in jobRoles"
                          :key="fndItemsKey"
                          @click="
                            onHandleRoleSelect(
                              fndItems.job_role_id,
                              fndItems.job_role
                            )
                          "
                          >{{ fndItems.job_role }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 pl-md-0">
                <button class="btn btn-primary w-100">SEARCH</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 mx-auto mb-3"
        >
          <div class="font-weight-600">
            {{ filteredJobs.length }} jobs found
          </div>
        </div>
        <div
          :key="careersKey"
          v-for="(careers, careersKey) in filteredJobs"
          class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 mx-auto mb-4"
        >
          <div class="careers-result-box">
            <div class="row">
              <div class="col-md-9 col-lg-10 align-self-center">
                <p class="mb-0">{{ careers.job_role }}</p>
                <div class="lh-1 my-3 my-md-0">
                  <span>Experience</span>
                  <strong>{{ careers.experience }} Year(s)</strong>
                </div>
                <div class="lh-1 my-3 my-md-0">
                  <span>Qualification</span>
                  <strong>{{ careers.job_qualification }} </strong>
                </div>
              </div>
              <div class="col-md-3 col-lg-2 align-self-center">
                <router-link
                  to
                  @click.native="
                    () =>
                      $router.push({
                        name: 'Careers Form',
                        params: { job_id: careers.job_id },
                      })
                  "
                  class="btn btn-primary w-md-100"
                  >Apply</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-space-100"></div>
    </div>
  </section>
</template>

<script>
import JobService from "@/apiServices/JobService";
import LocationService from "@/apiServices/LocationService";
import ExtrasService from "@/apiServices/ExtrasService";
export default {
  data() {
    return {
      jobs: [],
      filteredJobs: [],
      jobRoles: [],
      jobDepartments: [],
      cities: [],
      selectedCity: null,
      selectedDepartment: null,
      selectedRole: null,
      customer_care_email: null,
      paragraph: `<p>
        We strongly believe that the quality of our customer service directly reflects to how satisfied and united our employees are.<br/>
        A fun loving workplace & regarded as one of the best employers, our continual commitment towards employee 
        development has become one of its success story. At Miraj, we recognize that the real strength and 
        the foundation of our business are Our People. We firmly believe in growing our people holistically & build careers.<br/>
        To be part of this vibrant team, send in your resume at 
        <a class="text-rose-gold" href="mailto:contactus@mirajcinemas.com">contactus@mirajcinemas.com</a>
      </p>`,
    };
  },
  computed: {
    updatedParagraph() {
      if (!this.customer_care_email) return this.paragraph;

      // Create a DOM parser to extract href and email text from API HTML
      const temp = document.createElement('div');
      temp.innerHTML = this.customer_care_email;

      const newLink = temp.querySelector('a');
      if (!newLink) return this.paragraph;

      const newHref = newLink.getAttribute('href');
      const newText = newLink.textContent.trim();

      // Replace any existing <a href="mailto:...">...</a> with the new one
      return this.paragraph.replace(
        /<a[^>]*href="mailto:[^"]+"[^>]*>.*?<\/a>/i,
        `<a class="text-rose-gold" href="${newHref}">${newText}</a>`
      );
    },
  },
  beforeMount() {
    this.getJobs();
    this.getJobRoles();
    this.getJobDepartments();
    this.getCities();
  },
  async mounted() {
    await this.getCustomerCareEmail();
  },
  methods: {
    async getJobs() {
      const { data } = await JobService.GetJobs();
      if (data && data.status) {
        this.jobs = data.data;
        this.filterJobs();
      }
    },
    async getJobRoles() {
      const { data } = await JobService.GetJobRoles();
      if (data && data.status) {
        this.jobRoles = data.data;
      }
    },
    async getJobDepartments() {
      const { data } = await JobService.GetJobDepartments();
      if (data && data.status) {
        this.jobDepartments = data.data;
      }
    },
    async getCities() {
      const { data } = await LocationService.GetCities();
      if (data && data.status) {
        this.cities = data.data;
      }
    },
    async getCustomerCareEmail() {
      try {
        const response = await ExtrasService.getCustomerCareEmail();
        if (response.data.status) {
          this.customer_care_email = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting customer care email ", err);
      }
    },
    filterJobs() {
      this.filteredJobs = this.jobs.filter((job) => job.is_active === 'Y');

      //  city filter 
      if (this.selectedCity) {
        this.filteredJobs = this.filteredJobs.filter(
          (job) => job.city_id === this.selectedCity
        );
      }

      //  department filter
      if (this.selectedDepartment) {
        this.filteredJobs = this.filteredJobs.filter(
          (job) => job.job_department_id === this.selectedDepartment
        );
      }

      //  role filter 
      if (this.selectedRole) {
        this.filteredJobs = this.filteredJobs.filter(
          (job) => job.job_role_id === this.selectedRole
        );
      }
    },
    onHandleCitySelect(city_id, city_name) {
      console.log("onHandleCitySelect -> city_id", city_id);
      this.selectedCity = city_name;
      this.filteredJobs = this.jobs.filter((job) => job.city_id === city_id);
    },
    onHandleDepartmentSelect(job_department_id, department_name) {
      this.selectedDepartment = department_name;
      this.filteredJobs = this.jobs.filter(
        (job) => job.job_department_id === job_department_id
      );
    },
    onHandleRoleSelect(job_role_id, role_name) {
      this.selectedRole = role_name;
      this.filteredJobs = this.jobs.filter(
        (job) => job.job_role_id === job_role_id
      );
    },
  },
};
</script>
<style>
.career-dropdown .has-chevron .dropdown .dropdown-menu {
  max-height: 350px;
  overflow-y: auto;
  background: var(--bg-dark-2);
  color: #fff !important; 
}
.career-dropdown .has-chevron .dropdown .dropdown-item {
  color: #fff !important;
}
.career-dropdown .dropdown-item:hover, .career-dropdown  .dropdown-item:focus {
  background: var(--rose-gold);
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/careers.vue